import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Route, Link } from 'react-router-dom'

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';

import AnalyticsIcon from '@material-ui/icons/Timeline';
import ExceptionsIcon from '@material-ui/icons/ReportProblem';

import Loading from 'app/components/loaders/Loading';

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        marginBottom: theme.spacing(4),
    },
    button: {
        display: 'flex',
        justifyContent: 'flex-start'
    },
    leftIcon: {
        marginRight: theme.spacing(1),
    },
    table: {
        minWidth: '100%',
    },
    tableWrapper: {
        overflowX: 'auto',
    },
});

class Analytics extends React.Component {

    state = {

        loading: false,
        page: 0,
        rowsPerPage: 10,
        order: 'desc',
        orderBy: 'created_at',

        // Analytics
        members: [],
        exceptions: [],
    }

    componentDidMount() {
        this.getAnalytics();
        this.trackPage();
    }

    getAnalytics() {
        this.setState({ loading: true });

        api.get('/admin/analytics/get')
            .then(res => {
                const members = res.overview;
                const exceptions = res.exceptions;

                this.setState({ members, exceptions });

            }).catch(error => {
                console.log(error.response);
            }).then(() => {
                this.setState({ loading: false });
            });
    }

    trackPage() {
        api.get('/track/admin/analytics');
    }

    tabLinkColor = tab => {
        if (tab === this.props.location.pathname) return "primary";
        return "default";
    }

    handleRequestSort(property) {
        const isDesc = this.state.orderBy === property && this.state.order === 'desc';
        this.setState({ order: isDesc ? 'asc' : 'desc', orderBy: property });
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    }

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    }

    render() {
        const { classes } = this.props;
        const { members, exceptions, rowsPerPage, page, order, orderBy } = this.state;

        const Overview = () => {
            return (
                <div>
                    <Typography variant="h4" gutterBottom>Overview</Typography>
                    <Grid container>
                        <Grid item xs={6}>
                            <Typography variant="subtitle1">
                                Members that have Signed On
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="body1" color="primary" display="inline">
                                {members.loggedIn}&nbsp;
                            </Typography>
                            <Typography variant="body1" color="textSecondary" display="inline">
                                / {members.total}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="subtitle1">
                                Members Signed On in Last 7 Days
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="body1" color="primary" display="inline">
                                {members.loggedLast7}&nbsp;
                            </Typography>
                            <Typography variant="body1" color="textSecondary" display="inline">
                                / {members.total}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="subtitle1">
                                Members Signed On in Last 30 Days
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="body1" color="primary" display="inline">
                                {members.loggedLast30}&nbsp;
                            </Typography>
                            <Typography variant="body1" color="textSecondary" display="inline">
                                / {members.total}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="subtitle1">
                                Members Signed On in Last 90 Days
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="body1" color="primary" display="inline">
                                {members.loggedLast90}&nbsp;
                            </Typography>
                            <Typography variant="body1" color="textSecondary" display="inline">
                                / {members.total}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="subtitle1">
                                Members with Saved Card
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="body1" color="primary" display="inline">
                                {members.savedCard}&nbsp;
                            </Typography>
                            <Typography variant="body1" color="textSecondary" display="inline">
                                / {members.total}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="subtitle1">
                                Members Registered for Auto-Pay
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="body1" color="primary" display="inline">
                                {members.autoPay}&nbsp;
                            </Typography>
                            <Typography variant="body1" color="textSecondary" display="inline">
                                / {members.total}
                            </Typography>
                        </Grid>
                    </Grid>

                </div>
            )
        }

        const emptyRows = rowsPerPage - Math.min(rowsPerPage, exceptions.length - page * rowsPerPage);

        const Exceptions = () => {
            return (
                <div>
                    <Typography variant="h4" gutterBottom>Exceptions</Typography>
                    <div className={classes.tableWrapper}>
                        <Table className={classes.table} aria-labelledby="tableTitle">
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        padding='default'
                                        sortDirection={orderBy === 'instances' ? order : false}
                                        >
                                        <Tooltip
                                            title="Sort"
                                            placement='bottom-start'
                                            enterDelay={300}
                                            >
                                            <TableSortLabel
                                                active={orderBy === 'instances'}
                                                direction={order}
                                                onClick={() => this.handleRequestSort('instances')}
                                                >
                                                # of Instances
                                            </TableSortLabel>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell
                                        padding='default'
                                        sortDirection={orderBy === 'created_at' ? order : false}
                                        >
                                        <Tooltip
                                            title="Sort"
                                            placement='bottom-start'
                                            enterDelay={300}
                                            >
                                            <TableSortLabel
                                                active={orderBy === 'created_at'}
                                                direction={order}
                                                onClick={() => this.handleRequestSort('created_at')}
                                                >
                                                Last Exception
                                            </TableSortLabel>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell
                                        padding='default'
                                        sortDirection={orderBy === 'message' ? order : false}
                                        >
                                        <Tooltip
                                            title="Sort"
                                            placement='bottom-start'
                                            enterDelay={300}
                                            >
                                            <TableSortLabel
                                                active={orderBy === 'message'}
                                                direction={order}
                                                onClick={() => this.handleRequestSort('message')}
                                                >
                                                Message
                                            </TableSortLabel>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell padding='default'>File</TableCell>
                                    <TableCell padding='default'>Line</TableCell>
                                    <TableCell padding='default'>Code</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {stableSort(exceptions, getSorting(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map(n => {
                                        return (
                                            <TableRow
                                                hover
                                                tabIndex={-1}
                                                key={n.id}
                                                >
                                                <TableCell>{n.instances}</TableCell>
                                                <TableCell>{n.created_at}</TableCell>
                                                <TableCell>{n.message}</TableCell>
                                                <TableCell>{n.data_b}</TableCell>
                                                <TableCell>{n.data_c}</TableCell>
                                                <TableCell>{n.data_a}</TableCell>
                                            </TableRow>
                                        );
                                    })
                                }
                                {emptyRows > 0 && (
                                    <TableRow style={{ height: 49 * emptyRows }}>
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </div>
                    <TablePagination
                        rowsPerPageOptions={[10, 20, 50, 100]}
                        component="div"
                        count={exceptions.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        backIconButtonProps={{
                            'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'Next Page',
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                </div>
            )
        }

        return (

            <div className="content-container">
                <div className="container">
                    <Grid container spacing={2}>
                        <Grid item xs={2} component="nav">
                            <Link to="/admin/analytics">
                                <Button
                                    color={this.tabLinkColor("/admin/analytics")}
                                    fullWidth
                                    classes={{ label: classes.button }}
                                    size="small"
                                    >
                                    <AnalyticsIcon className={classes.leftIcon}/>
                                    Overview
                                </Button>
                            </Link>
                            <Link to="/admin/analytics/exceptions">
                                <Button
                                    color={this.tabLinkColor("/admin/analytics/exceptions")}
                                    fullWidth
                                    classes={{ label: classes.button }}
                                    size="small"
                                    >
                                    <ExceptionsIcon className={classes.leftIcon}/>
                                    Exceptions
                                </Button>
                            </Link>
                        </Grid>
                        <Grid item xs={10}>
                            <Paper className={classes.root} elevation={2}>
                                <Loading isLoading={this.state.loading}/>

                                <Route path="/admin/analytics" exact component={Overview}/>
                                <Route path="/admin/analytics/exceptions" exact component={Exceptions}/>

                            </Paper>
                        </Grid>
                    </Grid>
                </div>
            </div>

        );
    }
}

Analytics.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Analytics);
